import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  useGetProfileQuery,
  useGetScheduleCategoriesQuery,
  useGetServicesQuery,
  usePatchProfileMutation,
  usePostAppointmentMutation,
  usePostNotificationMutation,
} from "../redux/query/endpoints";
import dayjs from "dayjs";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";
import { AppointmentRequest } from "../models/AppointmentRequest";
import { DatePicker, PickersDay } from "@mui/lab";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  IconButton,
  LinearProgress,
  Snackbar,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { Icon } from "@iconify/react";
import {
  wp_assoc,
  wp_categories,
  wp_center,
  wp_provider,
} from "../data_from_wp";
import { groupBy, timeAndDate } from "../utils";
import app, { db } from "../firebase/app";
import {
  ConfirmationResult,
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "@firebase/auth";
import { useAppSelector } from "../redux/hooks";
import { selectToken } from "../redux/reducers/authSlice";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  setDoc,
} from "@firebase/firestore";

const Home = () => {
  const auth = getAuth(app);

  const firebase_route = ("00000" + wp_provider).slice(-5) + "_" + wp_center;

  const signInBtn = useRef<HTMLButtonElement>(null);

  if (signInBtn.current) {
    // @ts-ignore
    window.recaptchaVerifier = new RecaptchaVerifier(
      signInBtn.current,
      {
        size: "invisible",
        callback: (response: any) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
        },
      },
      auth
    );
  }

  // @ts-ignore
  const appVerifier = window.recaptchaVerifier;
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmationResult, setConfirmationResult] = useState<
    ConfirmationResult | undefined
  >();
  const [needRegister, setNeedRegister] = useState(false);
  const [codeVerified, setCodeVerified] = useState(false);

  const handleLoginWithPhone: React.FormEventHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        "+34" + phone,
        appVerifier
      );
      setConfirmationResult(confirmationResult);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Firebase error: ", err);
    }
  };

  const handleVerifyCode: React.FormEventHandler = async (e) => {
    e.preventDefault();
    if (confirmationResult && code) {
      try {
        const user = await confirmationResult.confirm(code);
        setCodeVerified(true);
        // handleContinue();
        // set_login_modal(false);
        // setConfirmationResult(undefined);
        // refetch();
      } catch (err) {
        setError("¡El código es inválido!");
        console.error(err);
      }
    }
  };

  const error_messages = {
    select_service: "¡Selecciona algún servicio!",
  };
  const step_number = 3;

  const [selectedServices, setSelectedServices] =
    useState<{ [id: number]: boolean }>();
  const [err, setErr] = useState<
    FetchBaseQueryError | SerializedError | undefined
  >(undefined);

  const [duration, setDuration] = useState<{ [id_category: number]: number }>();

  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );

  const [unavailableHours, setUnavailableHours] =
    useState<{ [id_category: number]: string[] }>();

  const [isYearPickerOpen, setIsYearPickerOpen] = useState(false);

  const [filter, setFilter] = useState("");

  const [error_msg, setError] = useState("");

  const [customer_comment, set_customer_comment] = useState("");

  const user_logged_in = useAppSelector(selectToken);

  const [login_modal, set_login_modal] = useState(false);

  const [requests, setRequests] = useState<AppointmentRequest[] | undefined>();

  const [selectedHour, setSelectedHour] = useState<{ [key: number]: string }>();
  const { data: servicesData, isLoading } = useGetServicesQuery({
    limit: 9999,
    start: 0,
  });

  const [step, setStep] = useState(0);

  const goBack = () => {
    set_customer_comment("");
    setStep((prev) => {
      if (prev !== 0) {
        return prev - 1;
      }
      return prev;
    });
  };

  const goNext = () =>
    setStep((prev) => {
      if (prev < step_number - 1) {
        return prev + 1;
      }
      return prev;
    });

  const handleContinue = () => {
    goNext();
  };

  // @ts-ignore
  window.db = db;
  // @ts-ignore
  window.collection = collection;
  // @ts-ignore
  window.doc = doc;

  const [message, setMessage] = useState("");

  const [postNotification] = usePostNotificationMutation();
  const [register] = usePatchProfileMutation();

  const { data: profileData } = useGetProfileQuery(undefined, {
    skip: !user_logged_in,
  });

  const [registerData, setRegisterData] = useState({
    name: "",
    email: "",
  });

  const handleRegister = async () => {
    const data = await register(registerData);
  };

  const getServiceById = (id: number) =>
    servicesData?.data.find((service) => service.id === id);

  const getServicesArray = useCallback(() => {
    return (
      servicesData?.data
        ?.filter((service) => {
          return !!(selectedServices && selectedServices[service.id]);
        })
        .map((service) => service) || []
    );
  }, [selectedServices, servicesData?.data]);

  const [postAppointment, { isLoading: isPosting }] =
    usePostAppointmentMutation();

  const {
    data: schedulesData,
    isLoading: isShedulesLoading,
    refetch,
    error,
  } = useGetScheduleCategoriesQuery(
    {
      date: selectedDate,
      servicesId: getServicesArray().map((service) => service.id),
    },
    { skip: !selectedServices || Boolean(err) || !user_logged_in }
  );

  useEffect(() => {
    if (selectedDate && selectedServices) {
      refetch();
    }
  }, [refetch, selectedDate, selectedServices]);

  if (error && error !== err) {
    setErr(error);
  }

  useEffect(() => {
    if (login_modal) {
      if (user_logged_in) {
        if (profileData?.data.id) {
          handleContinue();
          set_login_modal(false);
          setConfirmationResult(undefined);
          refetch();
        } else {
          setNeedRegister(true);
        }
      }
    }
  }, [handleContinue, login_modal, profileData, refetch, user_logged_in]);

  const getHoursToDisable = (
    slots_to_disable: number,
    hours: string,
    minutes: string,
    back: boolean
  ) => {
    let firstHour = back
      ? dayjs().hour(Number(hours)).minute(Number(minutes)).add(15, "m")
      : dayjs().hour(Number(hours)).minute(Number(minutes));
    const hoursToDisable: string[] = [];

    slots_to_disable &&
      Array.from(Array(slots_to_disable).keys()).forEach(() => {
        firstHour = back ? firstHour.subtract(15, "m") : firstHour.add(15, "m");
        hoursToDisable.push(firstHour.format("HH:mm"));
      });
    return hoursToDisable;
  };

  useEffect(() => {
    const services_array = getServicesArray();
    let durations: { [id_category: number]: number } = {};
    for (const serv of services_array) {
      durations[serv.id_category] = durations[serv.id_category]
        ? durations[serv.id_category] + Number(serv.time)
        : Number(serv.time);
    }
    setDuration(durations);
  }, [getServicesArray, selectedServices]);

  useEffect(() => {
    const unavailableHours: { [id_category: number]: string[] } = {};
    for (const hour in selectedHour) {
      if (duration) {
        const category = Number(hour);
        const time = selectedHour[category];
        const [hours, minutes] = time.split(":");
        const slots_to_disable = duration[category] / 15 - 1;
        for (const cat in duration) {
          if (!unavailableHours[cat]) {
            unavailableHours[cat] = [];
          }
          unavailableHours[cat].push(
            ...getHoursToDisable(slots_to_disable, hours, minutes, false)
          );
          if (Number(cat) !== category) {
            const slots_to_disable = duration[cat] / 15 - 1;
            unavailableHours[cat].push(
              ...getHoursToDisable(slots_to_disable + 1, hours, minutes, true)
            );
          }
        }
      }
    }
    setUnavailableHours(unavailableHours);
  }, [duration, selectedHour]);

  useEffect(() => {
    refetch();
  }, [refetch, selectedServices]);

  const resetData = () => {
    setDuration(undefined);
    setUnavailableHours(undefined);
    setRequests(undefined);
    setSelectedHour(undefined);
  };

  useEffect(() => {
    if (profileData && !profileData.data?.id) {
      setCodeVerified(true);
    }
  }, [profileData]);

  const datetime_format = "YYYY-MM-DD HH:mm";

  const isMobile = useMediaQuery("(max-width:700px)");

  const getRequestObjects = () => {
    if (!selectedHour || !selectedDate || !duration) return;
    const services_array = getServicesArray();
    const requests: AppointmentRequest[] = [];
    Object.keys(selectedHour).forEach((key) => {
      const category_id = Number(key);
      const start_hour = selectedHour[category_id];
      const [hour, minutes] = start_hour.split(":");
      const start_datetime = dayjs(selectedDate)
        .set("hours", Number(hour))
        .set("minutes", Number(minutes));
      const end_datetime = start_datetime.add(duration[category_id], "minutes");
      const services = services_array
        .filter((service) => service.id_category === category_id)
        .map((service) => service.id)
        .join(",");

      const requestObj = {
        start_datetime: start_datetime.format(datetime_format),
        end_datetime: end_datetime.format(datetime_format),
        id_employee: -1,
        id_category: category_id,
        services,
        status: 1,
        customer_comment: customer_comment,
      };
      requests.push(requestObj);
    });
    if (requests.length > 0) {
      return requests;
    }
  };

  const getNotificationObjects = (
    request: AppointmentRequest,
    player_id: string
  ) => {
    const start = dayjs(request.start_datetime);
    const end = dayjs(request.end_datetime);
    const n1 = {
      headings: {
        es: "Enhorabuena!!",
        en: "Enhorabuena!!",
      },
      contents: {
        es: `Su cita, ${start.format(
          timeAndDate
        )}, se ha reservado correctamente ¡Nos vemos muy pronto!`,
        en: `Su cita, ${start.format(
          timeAndDate
        )}, se ha reservado correctamente ¡Nos vemos muy pronto!`,
      },
      include_player_ids: [player_id],
    };
    const n2 = {
      send_after: start.subtract(1, "hour").toDate(),
      headings: {
        es: `Tienes una cita con nosotros!!`,
        en: `Tienes una cita con nosotros!!`,
      },
      contents: {
        es: `Queremos recordarle que tiene una cita con nosotros hoy ${start.format(
          timeAndDate
        )} ¡Le esperamos!`,
        en: `Queremos recordarle que tiene una cita con nosotros hoy ${start.format(
          timeAndDate
        )} ¡Le esperamos!`,
      },
      include_player_ids: [player_id],
    };
    const n3 = {
      send_after: end.toDate(),
      headings: {
        es: `Que tal ha sido su experiencia?`,
        en: `Que tal ha sido su experiencia?`,
      },
      contents: {
        es: `Nos encantaría recibir su valoración acerca del servicio que ha recibido ¡Muchas gracias!`,
        en: `Nos encantaría recibir su valoración acerca del servicio que ha recibido ¡Muchas gracias!`,
      },
      include_player_ids: [player_id],
    };
    const n4 = {
      send_after: start.subtract(1, "day").toDate(),
      headings: {
        es: `Tienes una cita con nosotros!!`,
        en: `Tienes una cita con nosotros!!`,
      },
      contents: {
        es: `Queremos recordarle que tiene una cita con nosotros mañana ${start.format(
          timeAndDate
        )} ¡Le esperamos!`,
        en: `Queremos recordarle que tiene una cita con nosotros mañana ${start.format(
          timeAndDate
        )} ¡Le esperamos!`,
      },
      include_player_ids: [player_id],
    };
    return [n1, n2, n3, n4];
  };

  const handleAppointmentResume = () => {
    setRequests(undefined);
    setRequests(getRequestObjects());
  };

  const grouped_services =
    servicesData?.data &&
    groupBy(servicesData.data, (service) => service.wp_category);

  const handleServiceClick = (service_id: number) => {
    setSelectedServices((prevState) => {
      return prevState && prevState[service_id]
        ? {
            ...prevState,
            [service_id]: !prevState[service_id],
          }
        : { ...prevState, [service_id]: true };
    });
  };

  const handleBookAppointment = async () => {
    const player_id = profileData?.data?.onesignal_id;
    if (requests) {
      try {
        for (const request of requests) {
          const res = await postAppointment({ body: request });
          if ("data" in res) {
            if (player_id) {
              const notification_objects = getNotificationObjects(
                request,
                player_id
              );
              for (const notification of notification_objects) {
                postNotification({ oneSignalObj: notification });
              }
            }
          }
          if ("error" in res) {
            setError(
              "Lo sentimos, alguien acaba de reservar cita en este momento, vuelva a intentarlo"
            );
            setStep(1);
            setSelectedHour(undefined);
            setUnavailableHours(undefined);
            refetch();
          }
        }
        setStep(0);
        resetData();
        // const col = collection(db, "appointmentsPanel");
        // const document_ref = doc(col, firebase_route);
        // const appointments = await getDoc(document_ref);
        // // @ts-ignore
        // const appointment_count = appointments.data().appointments;
        // await setDoc(document_ref, {
        //   appointments: appointment_count + 1,
        // });

        setMessage("Tu cita se ha reservado correctamente!");
      } catch (err) {
        console.error(err);
        setStep(0);
        resetData();
      }
    }
  };

  const handleCloseSnack = () => {
    setError("");
    setMessage("");
  };

  const handleCloseDialog = () => {
    set_login_modal(false);
    setConfirmationResult(undefined);
  };

  const [dayNotAvailable, setDayNotAvailable] = useState(true);

  useEffect(() => {
    if (schedulesData?.data) {
      for (const category of schedulesData.data) {
        if (!category.schedule || category.schedule.length < 1) {
          setDayNotAvailable(true);
          return;
        }
      }
    }
    setDayNotAvailable(false);
  }, [schedulesData?.data]);

  return (
    <div
      style={{
        maxWidth: 1036,
        margin: "0 auto",
        paddingTop: 0,
        paddingBottom: "2rem",
        paddingRight: `${isMobile ? "1rem" : "0"}`,
        paddingLeft: `${isMobile ? "1rem" : "0"}`,
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      <Snackbar
        open={Boolean(error_msg)}
        autoHideDuration={4000}
        onClose={handleCloseSnack}
        color="error"
      >
        <Alert
          onClose={handleCloseSnack}
          severity="error"
          sx={{ width: "100%" }}
        >
          {error_msg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Boolean(message)}
        autoHideDuration={8000}
        onClose={handleCloseSnack}
      >
        <Alert
          onClose={handleCloseSnack}
          severity="success"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Dialog
        PaperProps={{ sx: { background: "rgba(255, 255, 255, 0.95)" } }}
        onClose={handleCloseDialog}
        open={login_modal}
      >
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
              alignItems: "stretch",
              maxWidth: 350,
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <span
                style={{
                  fontWeight: 400,
                  fontSize: 20,
                  textAlign: "center",
                  margin: 0,
                  fontStyle: "italic",
                  lineHeight: "21px",
                  display: "flex",
                  alignItems: "center",
                  textTransform: "uppercase",
                  gap: 8,
                  fontFamily:
                    'TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia, serif',
                }}
              >
                {!confirmationResult && !codeVerified && "Número de teléfono"}
              </span>
            </div>
            {!confirmationResult && !codeVerified && <Divider />}
            <>
              {!confirmationResult && !codeVerified && (
                <>
                  <form
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                    onSubmit={handleLoginWithPhone}
                  >
                    <input
                      style={{
                        textAlign: "center",
                        fontSize: 18,
                        boxSizing: "border-box",
                        display: "flex",
                        width: "100%",
                        minHeight: 40,
                        background: "transparent",
                        padding: "0 20px",
                        border: "1px solid black",
                        borderRadius: 2,
                      }}
                      type="phone"
                      value={phone}
                      autoFocus={true}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="Número de teléfono"
                    />
                    <span style={{ fontSize: 12, color: "#4E4E4E" }}>
                      *Es necesario que regístre su número de teléfono para
                      poder reservar la cita.
                    </span>
                    <button
                      type={"submit"}
                      ref={signInBtn}
                      disabled={loading}
                      style={{
                        background: "black",
                        cursor: "pointer",
                        color: "white",
                        borderRadius: "5px",
                        fontWeight: 500,
                        border: "none",
                        padding: "5px 18px",
                        textTransform: "uppercase",
                        fontSize: 16,
                        width: "max-content",
                        margin: "0 auto",
                      }}
                    >
                      Enviar
                    </button>
                    {loading && <LinearProgress color="inherit" />}
                  </form>
                </>
              )}

              {confirmationResult && !needRegister && !codeVerified && (
                <form
                  style={{ display: "flex", flexDirection: "column", gap: 10 }}
                  onSubmit={handleVerifyCode}
                >
                  <input
                    style={{
                      textAlign: "center",
                      fontSize: 18,
                      boxSizing: "border-box",
                      display: "flex",
                      width: "100%",
                      minHeight: 40,
                      background: "transparent",
                      padding: "0 20px",
                      border: "1px solid black",
                      borderRadius: 2,
                    }}
                    autoFocus={true}
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="Introduce el código recibido"
                  />
                  <button
                    style={{
                      background: "black",
                      cursor: "pointer",
                      color: "white",
                      borderRadius: "5px",
                      fontWeight: 500,
                      border: "none",
                      padding: "5px 18px",
                      textTransform: "uppercase",
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: 16,
                      width: "max-content",
                      margin: "0 auto",
                    }}
                    type="submit"
                  >
                    Confirmar
                  </button>
                </form>
              )}
              {needRegister && (
                <form
                  style={{ display: "flex", flexDirection: "column", gap: 10 }}
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleRegister();
                  }}
                >
                  <input
                    style={{
                      textAlign: "center",
                      fontSize: 18,
                      boxSizing: "border-box",
                      display: "flex",
                      width: "100%",
                      minHeight: 40,
                      background: "transparent",
                      padding: "0 20px",
                      border: "1px solid black",
                      borderRadius: 2,
                    }}
                    type="text"
                    required
                    value={registerData.name}
                    onChange={(e) =>
                      setRegisterData({ ...registerData, name: e.target.value })
                    }
                    placeholder="Nombre y apellidos*"
                  />
                  <input
                    style={{
                      textAlign: "center",
                      fontSize: 18,
                      boxSizing: "border-box",
                      display: "flex",
                      width: "100%",
                      minHeight: 40,
                      background: "transparent",
                      padding: "0 20px",
                      border: "1px solid black",
                      borderRadius: 2,
                    }}
                    type="text"
                    value={registerData.email}
                    onChange={(e) =>
                      setRegisterData({
                        ...registerData,
                        email: e.target.value,
                      })
                    }
                    placeholder="Email"
                  />
                  <button
                    style={{
                      background: "black",
                      cursor: "pointer",
                      color: "white",
                      borderRadius: "5px",
                      fontWeight: 500,
                      border: "none",
                      padding: "5px 18px",
                      textTransform: "uppercase",
                      fontSize: 16,
                      fontFamily: "'Montserrat', sans-serif",
                      width: "max-content",
                      margin: "0 auto",
                    }}
                    type="submit"
                  >
                    Registro
                  </button>
                </form>
              )}
            </>
          </div>
        </DialogContent>
      </Dialog>
      {step === 0 && (
        <div>
          <p>Paso 1 de 3</p>
          <div
            style={{
              border: "1px solid black",
              borderRadius: 5,
              display: "flex",
              marginBottom: 48,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRight: "1px solid black",
                padding: "10px 15px",
              }}
            >
              <Icon style={{ fontSize: 24 }} icon="clarity:search-line" />
            </div>
            <div
              style={{
                padding: "0 25px",
                display: "flex",
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="text"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                placeholder="Buscar"
                style={{
                  fontSize: 16,
                  outline: "none",
                  border: "none",
                  background: "transparent",
                  width: "100%",
                }}
              />
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 40 }}>
            {grouped_services &&
              Array.from(grouped_services.keys()).map((cat) => {
                const category_services = grouped_services
                  .get(cat)
                  ?.filter((service) =>
                    service.name.toLowerCase().includes(filter.toLowerCase())
                  );

                return (
                  category_services &&
                  category_services.length > 0 && (
                    <Accordion
                      key={cat || "uncategorized"}
                      elevation={0}
                      sx={{ background: "transparent", color: "black" }}
                    >
                      <AccordionSummary
                        sx={{ padding: 0, borderBottom: "1px solid black" }}
                        expandIcon={
                          <Icon
                            style={{ fontSize: 32, color: "black" }}
                            icon="akar-icons:chevron-down"
                          />
                        }
                      >
                        <h1
                          style={{
                            fontWeight: 300,
                            fontSize: 20,
                            lineHeight: "24px",
                            margin: 0,
                            color: "black",
                            textTransform: "uppercase",
                            // padding: "8px 0",
                          }}
                        >
                          {cat || "Sin categoría"}
                        </h1>
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{
                          paddingTop: "30px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "20px",
                        }}
                      >
                        {category_services.map((service) => {
                          const isSelected =
                            selectedServices && selectedServices[service.id];
                          return (
                            <div
                              key={(cat || "uncategorized") + service.id}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleServiceClick(service.id);
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                border: isMobile ? "1px solid black" : "none",
                                flexDirection: "column",
                                borderRadius: 5,
                                gap: 14,
                                padding: `${isSelected ? "20px" : "20px"} ${
                                  isSelected ? "10px" : "10px"
                                }`,
                                background: isSelected
                                  ? "rgba(255,255,255,0.3)"
                                  : "transparent",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: isMobile ? "column" : "row",
                                  fontWeight: 300,
                                  fontSize: 16,
                                  lineHeight: "20px",
                                  textAlign: "justify",
                                  gap: 15,
                                }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 15,
                                  }}
                                >
                                  <div
                                    style={{
                                      fontWeight: 400,
                                      fontSize: 18,
                                      fontStyle: "italic",
                                      lineHeight: "21px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 8,
                                      fontFamily:
                                        'TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia, serif',
                                    }}
                                  >
                                    {isSelected && (
                                      <Icon
                                        style={{ color: "green", fontSize: 24 }}
                                        icon="akar-icons:circle-check-fill"
                                      />
                                    )}
                                    <span
                                      style={{
                                        lineHeight: "21px",
                                        textAlign: "left",
                                      }}
                                    >
                                      {service.name.toUpperCase()}
                                    </span>
                                  </div>
                                  {/* <div
                                    style={{
                                      display: "flex",
                                      gap: 5,
                                      alignItems: "center",
                                    }}
                                  >
                                    <Icon
                                      style={{ fontSize: 18 }}
                                      icon="ant-design:field-time-outlined"
                                    />
                                    <span style={{ lineHeight: "19.5px" }}>
                                      {service.time + " minutos"}
                                    </span>
                                  </div> */}
                                  <div
                                    style={{
                                      height: 1,
                                      visibility: isMobile
                                        ? "hidden"
                                        : "visible",
                                      flexGrow: 1,
                                      background: "black",
                                    }}
                                  ></div>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    gap: 5,
                                    alignItems: "center",
                                  }}
                                >
                                  <Icon
                                    style={{ fontSize: 18, flexShrink: 0 }}
                                    icon="ant-design:field-time-outlined"
                                  />
                                  <span
                                    style={{
                                      lineHeight: "19.5px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {service.time + " minutos"}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 15,
                                  }}
                                >
                                  <div
                                    style={{
                                      height: 1,
                                      visibility: isMobile
                                        ? "hidden"
                                        : "visible",
                                      flexGrow: 1,
                                      background: "black",
                                    }}
                                  ></div>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleServiceClick(service.id);
                                    }}
                                    className="big-button"
                                    style={{
                                      fontWeight: 500,
                                      cursor: "pointer",
                                      fontSize: 16,
                                      borderRadius: 2,
                                      color: isSelected ? "black" : "white",
                                      lineHeight: "20px",
                                      padding: "2px 20px",
                                      background: isSelected ? "white" : "",
                                      fontFamily: "'Montserrat', sans-serif",
                                      border: "1px solid black",
                                    }}
                                  >
                                    {isSelected ? "BORRAR" : "AÑADIR"}
                                  </button>
                                </div>
                              </div>
                              <div
                                style={{
                                  fontWeight: 300,
                                  fontSize: 16,
                                  lineHeight: "30px",
                                  textAlign: "justify",
                                  color: "#4E4E4E",
                                }}
                              >
                                {service.description}
                              </div>
                            </div>
                          );
                        })}
                      </AccordionDetails>
                    </Accordion>
                  )
                );
              })}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              position: "sticky",
              bottom: "20px",
              marginTop: "60px",
            }}
          >
            <button
              style={{
                cursor: "pointer",

                color: "white",
                borderRadius: "5px",
                fontWeight: 500,
                border: "none",
                padding: "5px 18px",
                textTransform: "uppercase",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 20,
              }}
              className="big-button"
              onClick={() => {
                if (selectedServices) {
                  for (const service_id in selectedServices) {
                    if (selectedServices[service_id] === true) {
                      if (profileData && profileData.data?.id) {
                        setSelectedHour(undefined);
                        return handleContinue();
                      } else {
                        setSelectedHour(undefined);
                        return set_login_modal(true);
                      }
                    }
                  }
                }

                if (error_msg !== error_messages.select_service) {
                  return setError(error_messages.select_service);
                }
              }}
            >
              Continuar
            </button>
          </div>
        </div>
      )}
      {step === 1 && (
        <div style={{ fontFamily: "" }}>
          <p>Paso 2 de 3</p>
          <div
            className="custom_dateinput"
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 52,
              marginBottom: 78,
            }}
          >
            <div
              style={{
                borderBottom: "1px solid black",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexGrow: 1,
              }}
            >
              <h1
                style={{
                  fontWeight: 300,
                  fontSize: 20,
                  lineHeight: "24px",
                  margin: 0,
                  padding: "8px 0",
                }}
              >
                SELECCIONE DÍA Y HORA
              </h1>
            </div>
            <div onClick={() => setIsYearPickerOpen(true)}>
              <DatePicker
                value={selectedDate || new Date()}
                disablePast
                renderDay={(day, selectedDates, props) => {
                  const d = day.get("day");

                  return <PickersDay {...props} disabled={d === 0} />;
                }}
                onChange={(newValue: dayjs.Dayjs | null) => {
                  if (newValue) {
                    setSelectedDate(newValue.format("YYYY-MM-DD"));
                    setUnavailableHours(undefined);
                    setSelectedHour(undefined);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    onFocus={(e) => e.preventDefault()}
                    {...params}
                    sx={{
                      background: "rgba(255, 255, 255, 0.4)",
                      "& .MuiOutlinedInput-root": {
                        "& > fieldset": {
                          borderColor: "black",
                          borderRadius: "5px",
                        },
                      },
                      "& .MuiOutlinedInput-root.Mui-focused": {
                        "& > fieldset": {
                          borderColor: "black",
                          borderRadius: "5px",
                        },
                      },
                    }}
                  />
                )}
              />
            </div>
          </div>

          {/* <p>
            Servicios seleccionados:
            {getServicesArray()
              .map((service) => service.id)
              .join(",")}
          </p> */}
          {dayNotAvailable && (
            <div>
              <p style={{ textAlign: "center", color: "grey" }}>
                Lo sentimos, no tenemos hueco para este día, prueba otra fecha
                distinta
              </p>
            </div>
          )}
          {!dayNotAvailable && (
            <div style={{ display: "flex", flexDirection: "column", gap: 40 }}>
              {schedulesData?.data?.map((category) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      background: "rgba(255,255,255,0.4)",
                      padding: !isMobile ? 35 : 16,
                      borderRadius: 5,
                    }}
                    key={category.id}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 32,
                      }}
                    >
                      <span
                        style={{
                          fontWeight: 300,
                          textTransform: "uppercase",
                          fontFamily: "'Montserrat', sans-serif",
                        }}
                      >
                        {category.name}
                      </span>
                      {/* <div>
                      <select>
                        <option value="-1">Cualquiera</option>
                      </select>
                    </div> */}
                      <div
                        style={{
                          display: "flex",
                          gap: 12,
                          alignItems: "center",
                        }}
                      >
                        <Icon
                          icon="ant-design:field-time-outlined"
                          style={{
                            fontSize: 18,
                            transform: "translateY(-1px)",
                          }}
                        />
                        <span style={{ fontWeight: 500, lineHeight: "29px" }}>
                          {duration && duration[category.id]}
                        </span>
                      </div>
                    </div>
                    <div
                      className="schedules_container"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        // width: "max-content",
                        gap: !isMobile ? 18 : 12,
                      }}
                    >
                      {category.schedule?.map((hour) => {
                        const disabled =
                          unavailableHours &&
                          unavailableHours[category.id]?.includes(hour.hour);
                        return (
                          <button
                            key={hour.hour}
                            className="hour_button"
                            onClick={() => {
                              if (
                                selectedHour &&
                                selectedHour[category.id] &&
                                selectedHour[category.id] === hour.hour
                              ) {
                                return setSelectedHour((prevState) => {
                                  if (prevState) {
                                    prevState[category.id] = "";

                                    return { ...prevState };
                                  }
                                });
                              } else {
                                return setSelectedHour((prevState) => ({
                                  ...prevState,
                                  [category.id]: hour.hour,
                                }));
                              }
                            }}
                            disabled={disabled || !hour.available}
                            style={{
                              boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.25)",
                              fontFamily: "'Montserrat', sans-serif",
                              padding: !isMobile ? " 8px 30px" : "4px 8px",
                              fontWeight: 600,
                              fontSize: !isMobile ? 18 : 14,
                              width: !isMobile ? 105 : 60,
                              borderRadius: 3,
                              color: "white",
                              background: hour.available
                                ? disabled
                                  ? "#C4C4C4"
                                  : selectedHour &&
                                    selectedHour[category.id] &&
                                    selectedHour[category.id] === hour.hour
                                  ? "#4489C8"
                                  : "#C6D2B9"
                                : "#C4C4C4",
                              border: "none",
                            }}
                          >
                            {hour.hour}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <div
            style={{
              display: "flex",
              gap: 16,
              marginTop: 40,
              justifyContent: "center",
            }}
          >
            <button
              style={{
                cursor: "pointer",
                color: "white",
                borderRadius: "5px",
                fontWeight: 500,
                border: "none",
                padding: "5px 18px",
                textTransform: "uppercase",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 20,
              }}
              className="big-button"
              onClick={() => {
                goBack();
              }}
            >
              Atrás
            </button>
            <button
              style={{
                cursor: "pointer",
                color: "white",
                borderRadius: "5px",
                fontWeight: 500,
                border: "none",
                padding: "5px 18px",
                textTransform: "uppercase",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 20,
              }}
              className="big-button"
              onClick={() => {
                for (const d in duration) {
                  if (!selectedHour || !selectedHour[Number(d)]) {
                    return setError("¡Selecciona alguna hora!");
                  }
                }
                handleAppointmentResume();
                goNext();
              }}
            >
              Siguiente
            </button>
          </div>
        </div>
      )}
      {step === 2 && (
        <div>
          <p>Paso 3 de 3</p>

          <p
            style={{
              fontSize: 20,
              fontWeight: 300,
              fontFamily: "'Montserrat', sans-serif",
              marginBottom: "10px",
            }}
          >
            RESUMEN DE TU CITA
          </p>
          <div style={{ width: "100%", height: "1px", background: "black" }} />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
              marginTop: 60,
              paddingBottom: 50,
            }}
          >
            {requests &&
              requests.map((request) => (
                <div
                  key={request.start_datetime}
                  style={{
                    background: "rgba(255, 255, 255, 0.4)",
                    borderRadius: "5px",
                    padding: 20,
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h1
                      style={{
                        fontWeight: 400,
                        fontSize: 20,
                        textTransform: "uppercase",
                        fontStyle: "italic",
                        lineHeight: "23px",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontFamily:
                          'TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia, serif',
                      }}
                    >
                      Servicios seleccionados
                    </h1>
                    <div
                      style={{
                        display: "flex",
                        gap: 5,
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        style={{ fontSize: 18 }}
                        icon="ant-design:field-time-outlined"
                      />
                      <span style={{ lineHeight: "19.5px" }}>{12 + "''"}</span>
                    </div>
                  </div>
                  <Divider />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "16px 0",
                      gap: 8,
                    }}
                  >
                    {request.services.split(",").map((service_id) => {
                      const service = getServiceById(Number(service_id));
                      return (
                        <div key={service_id}>
                          {service && (
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "space-between",
                              }}
                            >
                              <span>
                                <span
                                  style={{ fontWeight: "bold", fontSize: 24 }}
                                >
                                  ·{" "}
                                </span>
                                {service.name}
                              </span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <Divider />
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 16,
                      paddingTop: "20px",
                    }}
                  >
                    <div style={{ display: "flex", gap: 16 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <Icon
                          icon="bi:calendar-check"
                          style={{ fontSize: 18 }}
                        />
                        <span>
                          {dayjs(request.start_datetime).format("DD/MM/YYYY")}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <Icon
                          icon="ant-design:field-time-outlined"
                          style={{ fontSize: 18 }}
                        />
                        <span>
                          {dayjs(request.start_datetime).format("HH:mm")}
                        </span>
                      </div>
                    </div>
                    <span style={{ fontWeight: "bold", fontSize: 18 }}>
                      {" "}
                      -{" "}
                    </span>
                    <div style={{ display: "flex", gap: 16 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <Icon
                          icon="bi:calendar-check"
                          style={{ fontSize: 18 }}
                        />
                        <span>
                          {dayjs(request.end_datetime).format("DD/MM/YYYY")}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <Icon
                          icon="ant-design:field-time-outlined"
                          style={{ fontSize: 18 }}
                        />

                        <span>
                          {dayjs(request.end_datetime).format("HH:mm")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            <div
              style={{
                background: "rgba(255, 255, 255, 0.4)",
                borderRadius: "5px",
                padding: 20,
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h1
                  style={{
                    fontWeight: 400,
                    fontSize: 20,
                    textTransform: "uppercase",
                    fontStyle: "italic",
                    lineHeight: "23px",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontFamily:
                      'TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia, serif',
                  }}
                >
                  Observaciones
                </h1>
              </div>
              <Divider />
              <input
                style={{
                  background: "transparent",
                  color: "#4E4E4E",
                  fontWeight: 300,
                  fontSize: 18,
                  width: "100%",
                  border: "none",
                  paddingTop: "20px",
                  fontFamily: "Montserrat",
                  outline: "none",
                }}
                value={customer_comment}
                onChange={(e) => set_customer_comment(e.target.value)}
                placeholder="¿Algún comentario sobre la cita?"
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: 16,
              justifyContent: "center",
            }}
          >
            <button
              style={{
                cursor: "pointer",
                color: "white",
                borderRadius: "5px",
                fontWeight: 500,
                border: "none",
                padding: "5px 18px",
                textTransform: "uppercase",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 20,
              }}
              className="big-button"
              onClick={() => {
                goBack();
              }}
            >
              Atrás
            </button>
            <button
              style={{
                cursor: "pointer",
                color: "white",
                borderRadius: "5px",
                fontWeight: 500,
                border: "none",
                padding: "5px 18px",
                textTransform: "uppercase",
                fontSize: 20,
                fontFamily: "'Montserrat', sans-serif",
              }}
              className="big-button"
              onClick={() => {
                handleBookAppointment();
              }}
            >
              Confirmar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
